import { Injectable } from '@angular/core';

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  route?: string;
}

/** Heroicons 24×24 outline path `d` values for the sidebar rail. */
export const SIDEBAR_ROUTE_ICONS = {
  dashboard:
    'M4 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6zm10 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6zM4 16a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2zm10 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2z',
  tenants:
    'M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z',
  documentEndpoints:
    'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9z',
} as const;

export const SHELL_NAV_ROUTES: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: SIDEBAR_ROUTE_ICONS.dashboard,
    route: '/dashboard',
  },
  {
    id: 'tenants',
    label: 'Tenants',
    icon: SIDEBAR_ROUTE_ICONS.tenants,
    route: '/tenants',
  },
  {
    id: 'document-endpoints',
    label: 'Document Endpoints',
    icon: SIDEBAR_ROUTE_ICONS.documentEndpoints,
    route: '/document-endpoints',
  },
];

@Injectable({ providedIn: 'root' })
export class NavService {
  findItemByRoute(route: string): NavItem | undefined {
    const matches = SHELL_NAV_ROUTES.filter(
      (s) => s.route !== undefined && (s.route === route || route.startsWith(s.route + '/')),
    );
    const sorted = [...matches].sort((a, b) => (b.route?.length ?? 0) - (a.route?.length ?? 0));
    return sorted[0];
  }
}
